export default "__VITE_ASSET__3708e4e9__"